import { lazy, Suspense } from 'react';
import {
  AboutPagePlaceholder,
  AddListingPagePlaceholder,
  AdminPagePlaceholder,
  ContactPagePlaceholder,
  PrivacyPagePlaceholder,
  PropertyPagePlaceholder,
  RequestPagePlaceholder,
  WishlistPagePlaceholder,
} from './placeholders';
import { ShopPlaceholder } from './placeholders/ShopPlaceholder.tsx';

const AboutPageLazy = lazy(() =>
  import('./about/AboutPage.tsx').then((module) => ({
    default: module.AboutPage,
  })),
);
export const AboutPage = () => (
  <Suspense fallback={<AboutPagePlaceholder />}>
    <AboutPageLazy />
  </Suspense>
);

const AddListingPageLazy = lazy(() =>
  import('./add-listing/AddListingPage.tsx').then((module) => ({
    default: module.AddListingPage,
  })),
);
export const AddListingPage = () => (
  <Suspense fallback={<AddListingPagePlaceholder />}>
    <AddListingPageLazy />
  </Suspense>
);

const AdminPageLazy = lazy(() =>
  import('./admin/AdminPage.tsx').then((module) => ({
    default: module.AdminPage,
  })),
);
export const AdminPage = () => (
  <Suspense fallback={<AdminPagePlaceholder />}>
    <AdminPageLazy />
  </Suspense>
);

const AdminMessagesPageLazy = lazy(() =>
  import('./admin/AdminMessagesPage.tsx').then((module) => ({
    default: module.AdminMessagesPage,
  })),
);
export const AdminMessagesPage = () => (
  <Suspense fallback={<AdminPagePlaceholder />}>
    <AdminMessagesPageLazy />
  </Suspense>
);

const ContactPageLazy = lazy(() =>
  import('./contact/ContactPage.tsx').then((module) => ({
    default: module.ContactPage,
  })),
);
export const ContactPage = () => (
  <Suspense fallback={<ContactPagePlaceholder />}>
    <ContactPageLazy />
  </Suspense>
);

const PrivacyPageLazy = lazy(() =>
  import('./privacy/PrivacyPage.tsx').then((module) => ({
    default: module.PrivacyPage,
  })),
);
export const PrivacyPage = () => (
  <Suspense fallback={<PrivacyPagePlaceholder />}>
    <PrivacyPageLazy />
  </Suspense>
);

const PropertyPageLazy = lazy(() =>
  import('./property/PropertyPage.tsx').then((module) => ({
    default: module.PropertyPage,
  })),
);
export const PropertyPage = () => (
  <Suspense fallback={<PropertyPagePlaceholder />}>
    <PropertyPageLazy />
  </Suspense>
);

const RequestPageLazy = lazy(() =>
  import('./request-property/RequestPage.tsx').then((module) => ({
    default: module.RequestPage,
  })),
);
export const RequestPage = () => (
  <Suspense fallback={<RequestPagePlaceholder />}>
    <RequestPageLazy />
  </Suspense>
);

const ShopLazy = lazy(() =>
  import('./shop/Shop.tsx').then((module) => ({
    default: module.Shop,
  })),
);
export const Shop = () => (
  <Suspense fallback={<ShopPlaceholder />}>
    <ShopLazy />
  </Suspense>
);

const WishlistPageLazy = lazy(() =>
  import('./wishlist/WishlistPage.tsx').then((module) => ({
    default: module.WishlistPage,
  })),
);
export const WishlistPage = () => (
  <Suspense fallback={<WishlistPagePlaceholder />}>
    <WishlistPageLazy />
  </Suspense>
);
